var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"majorProportion"},_vm._l((_vm.chartList),function(item,index){return _c('div',{key:index,staticClass:"index"},[_c('div',{staticClass:"problemCount",attrs:{"id":item.id}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }